var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCampaignConflict(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1648 17.0432H9.30981V18.9168H15.1648V17.0432Z",
    fill: "#37383A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1463 13.2961H9.30981V15.1697H19.1463V13.2961Z",
    fill: "#37383A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73825 22.6655H15.1671V21.0261H7.20665V7.20819H20.7903V14.9368H22.6639V6.50559C22.6696 5.59725 22.3766 5.32682 21.2587 5.33458H6.73825C5.78538 5.3143 5.39992 5.50713 5.33304 6.50559V21.0261C5.29892 22.384 5.62984 22.7144 6.73825 22.6655Z",
    fill: "#37383A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30981 11.4223V9.54871H19.1463V11.4223H9.30981Z",
    fill: "#37383A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0384 16.1063L16.1016 17.0431L18.4436 19.3851L16.1016 21.7272L17.0384 22.664L19.3804 20.3219L21.7224 22.664L22.6592 21.7272L20.3172 19.3851L22.6592 17.0431L21.7224 16.1063L19.3804 18.4483L17.0384 16.1063Z",
    fill: "#37383A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignConflict);
export default __webpack_public_path__ + "static/media/CampaignConflict.826da37ac9ac9cb6e686d5640fabf4c0.svg";
export { ForwardRef as ReactComponent };